import _defaultsDeep from "lodash/defaultsDeep";
import { Mode, Region } from "./constants/env";
import { LifeCycleEventName, StorageType } from "./constants/sdk";
import { BaseInfoModule } from "./modules/info-module";
import LifeCycleModule from "./modules/life-cycle-module";
import LoggingModule from "./modules/logging-module";
import ServiceModule from "./modules/service-module";
import StorageModule from "./modules/storage-module";
const DEFAULT_CONFIG = {
  appId: -1,
  domain: "",
  entityKeys: [],
  mode: Mode.PRODUCTION,
  isPPE: false,
  debug: false,
  fetchDataAtInit: true,
  region: Region.SG,
  storageType: StorageType.sessionStorage,
  modules: {
    info: new BaseInfoModule()
  }
};
class ConsentClientFrameworkSDK {
  constructor() {
    this._isInitialized = false;
    this._validateInitStatus = () => {
      if (!this._isInitialized) {
        console.error("[SDK]: SDK is used before init");
        return false;
      }
      return true;
    };
    this.getConsentRecord = (entityKey) => {
      if (!this._validateInitStatus()) {
        return null;
      }
      LoggingModule.info("[SDK]: getConsentRecord", { entityKey });
      return LifeCycleModule.getConsentRecord(entityKey);
    };
    this.getConsentRecords = (entityKeys) => {
      if (!this._validateInitStatus()) {
        return [];
      }
      LoggingModule.info("[SDK]: getConsentRecords", { entityKeys });
      return LifeCycleModule.getConsentRecords(entityKeys);
    };
    this.getConsentEntity = (entityKey) => {
      if (!this._validateInitStatus()) {
        return null;
      }
      LoggingModule.info("[SDK]: getConsentEntity", { entityKey });
      return LifeCycleModule.getConsentEntity(entityKey);
    };
    this.getConsentEntities = (entityKeys) => {
      if (!this._validateInitStatus()) {
        return [];
      }
      LoggingModule.info("[SDK]: getConsentEntities", { entityKeys });
      return LifeCycleModule.getConsentEntities(entityKeys);
    };
    this.updateConsentRecords = (params, status, businessFlow) => {
      if (!this._validateInitStatus()) {
        return Promise.resolve();
      }
      LoggingModule.info("[SDK]: updateConsentRecords", { params, status, businessFlow });
      return LifeCycleModule.updateConsentRecords(params, status, businessFlow);
    };
    this.removeNotification = (arg) => {
      if (!this._validateInitStatus()) {
        return;
      }
      LoggingModule.info("[SDK]: removeNotification", { arg });
      LifeCycleModule.removeNotification(arg);
    };
    this.notify = (arg) => {
      if (!this._validateInitStatus()) {
        return;
      }
      LoggingModule.info("[SDK]: notify", { arg });
      LifeCycleModule.notify(arg);
    };
    this.fetch = (arg) => {
      if (!this._validateInitStatus()) {
        return Promise.resolve();
      }
      LoggingModule.info("[SDK]: fetch", { arg });
      return LifeCycleModule.fetch(arg);
    };
    this.refresh = (arg) => {
      if (!this._validateInitStatus()) {
        return Promise.resolve();
      }
      LoggingModule.info("[SDK]: refresh", { arg });
      return LifeCycleModule.fetch(arg);
    };
    this.addEventListener = (eventName, id, callback) => {
      if (!this._validateInitStatus()) {
        return;
      }
      LoggingModule.info("[SDK]: addEventListener");
      if (!eventName || !LifeCycleEventName[eventName] || !id || typeof callback !== "function") {
        const errorMsg = "[SDK]: addEventListener - invalid param for adding new event listener";
        LoggingModule.error(errorMsg, new Error(errorMsg));
        return;
      }
      LifeCycleModule.addEventListener(eventName, id, callback);
    };
    this.removeEventListener = (eventName, id) => {
      if (!this._validateInitStatus()) {
        return;
      }
      LoggingModule.info("[SDK]: removeEventListener");
      LifeCycleModule.removeEventListener(eventName, id);
    };
    this.destruct = () => {
      LoggingModule.info("[SDK]: destruct");
      LifeCycleModule.destruct();
      ServiceModule.destruct();
      StorageModule.destruct();
      LoggingModule.destruct();
      this._isInitialized = false;
    };
    if (!ConsentClientFrameworkSDK._instance) {
      ConsentClientFrameworkSDK._instance = this;
    }
    return ConsentClientFrameworkSDK._instance;
  }
  init(config) {
    if (typeof window === "undefined") {
      console.warn("ConsentClientFrameworkSDK can not be init on server");
      return Promise.resolve();
    }
    if (this._isInitialized) {
      throw new Error("ConsentClientFrameworkSDK has been initialized");
    }
    const sdkConfig = _defaultsDeep({}, config, DEFAULT_CONFIG);
    const { debug, fetchDataAtInit } = sdkConfig;
    if (debug) {
      window.consentSDK = this;
      window.consentSDK.storage = StorageModule;
    }
    LoggingModule.init(sdkConfig);
    LoggingModule.info("[SDK]: init global module");
    ServiceModule.init(sdkConfig);
    StorageModule.init(sdkConfig);
    LoggingModule.info("[SDK]: init life cycle");
    LifeCycleModule.init(sdkConfig);
    this._isInitialized = true;
    if (fetchDataAtInit) {
      return LifeCycleModule.fetch();
    }
    return Promise.resolve();
  }
  isInitialized() {
    LoggingModule.info("[SDK]: isInitialized");
    return this._isInitialized;
  }
}
const instance = new ConsentClientFrameworkSDK();
var sdk_default = instance;
export {
  sdk_default as default
};
